<template>
  <div>
        <div v-loading="$store.getters.getLoadingState" style="display: flex; flex-direction: column; justify-content: space-between; align-items: space-between; width: 100%;">
            
            <div>
                <el-table
                    :data="$store.state.production.assignment_history
                        .filter(t => t.hidden_process === -1 && $store.state.production.assignment_history.filter(t1 => t1.main_work_log_id === t.id).length === 0)"
                    style="width: 100%">
                <el-table-column 
                    label="Staff">
                    <template slot-scope="scope">
                        <span class="rowFontSize">
                        <!--
                            <el-select 
                                size="small"
                                v-model="scope.row.worker_id" 
                                filterable 
                                style="width: 400px; text-align: left;">
                                <el-option
                                    v-for="(data, index) in $store.getters.getEmployeeMasterList"
                                    :key="index"
                                    :label="data.staff_name"
                                    :value="data.id">
                                    <span style="float: left" v-html="data.staff_name"></span>
                                </el-option>
                            </el-select>
                        -->
                        {{ scope.row.worker_id === 0 ? '-NA-' : scope.row.staff_name }}
                        </span>                        
                    </template>
                </el-table-column>
                <el-table-column 
                    label="Process">
                    <template slot-scope="scope">
                        <span class="rowFontSize">
                            {{scope.row.process_name}}
                        </span>
                    </template>
                </el-table-column>
                <el-table-column 
                    label="Status">
                    <template slot-scope="scope">
                        <span class="rowFontSize">
                            {{(scope.row.work_status === 0 ? 'Waiting' 
                            : scope.row.work_status === 1 ? 'Assigned' 
                                : scope.row.work_status === 2 ? 'Approval Pending' 
                                    : scope.row.work_status === 3 ? 'Work Rejected' : 'Work Accepted')}}
                        </span>
                    </template>
                </el-table-column>
                <el-table-column 
                    label="Started At" :width="$store.getters.getPreferenceProps.enable_work_order_assignment_date_change ? 230 : ''">
                    <template slot-scope="scope" v-if="scope.row.work_status>0">
                        <el-date-picker
                                v-if="$store.getters.getPreferenceProps.enable_work_order_assignment_date_change && scope.row.main_work_log_id === 0"
                                :type="'datetime'"
                                v-model="scope.row.started_at_changed_time"
                                :value-format="'yyyy-MM-dd HH:mm:ss'"
                                :format="'MMM dd yyyy hh:mm a'">
                        </el-date-picker>
                        <span v-else class="rowFontSize">
                            {{scope.row.started_at_changed_time}}                            
                        </span>
                        
                    </template>
                </el-table-column>
                <el-table-column 
                    label="Finished At" :width="$store.getters.getPreferenceProps.enable_work_order_assignment_date_change ? 230 : ''">
                    <template slot-scope="scope" v-if="scope.row.work_status>1">
                        <el-date-picker
                            v-if="!$store.getters.getPreferenceProps.enable_work_order_assignment_date_change && scope.row.main_work_log_id === 0" 
                            :type="'datetime'"
                            v-model="scope.row.finished_at_changed_time"
                            :value-format="'yyyy-MM-dd HH:mm:ss'"
                            :format="'MMM dd yyyy hh:mm a'">
                        </el-date-picker>
                        <span v-else class="rowFontSize">
                            {{scope.row.finished_at_changed_time}}                      
                        </span>
                        
                    </template>
                </el-table-column>
                    
                <el-table-column 
                    prop="t12.default_piece_rate"
                    label="Piece Rate" align="center">
                    <template slot-scope="scope" v-if="scope.row.work_status === 4">
                        <span class="rowFontSize">
                            {{formatCurrency(scope.row.default_piece_rate)}}
                        </span>
                    </template>
                </el-table-column>

                <el-table-column 
                    prop="t12.extra_payment"
                    label="Adjustment" align="center">
                    <template slot-scope="scope" v-if="scope.row.work_status === 4">
                        <el-input @focus="$event.target.select()"
                            size="small" 
                            v-if="scope.row.work_status>1 && scope.row.work_status !== 3 && scope.row.payroll_id === 0 && scope.row.main_work_log_id === 0"
                            type="number" 
                            :disabled="!$store.getters.getUserInformation.is_a_production_supervisor"
                            style="text-align: center; width: 100px;"
                            v-model="scope.row.extra_payment">
                        </el-input>                
                        <span v-else class="rowFontSize">
                            {{formatCurrency(scope.row.extra_payment)}}
                        </span>
                    </template>
                </el-table-column>

                <el-table-column 
                    prop="t12.total_piece_rate"
                    label="Net Piece Rate" align="center">
                    <template slot-scope="scope" v-if="scope.row.work_status === 4">
                        <span class="rowFontSize">
                            {{formatCurrency(scope.row.total_piece_rate = parseFloat(scope.row.default_piece_rate) + parseFloat(scope.row.extra_payment))}}
                        </span>
                    </template>
                </el-table-column>

                <el-table-column 
                    prop="t12.remarks"
                    label="Remarks" align="left" width="200">
                    <template slot-scope="scope" v-if="scope.row.work_status >=1">
                        <el-input @focus="$event.target.select()"
                            v-if="scope.row.work_status>1 && scope.row.payroll_id === 0 && scope.row.main_work_log_id === 0"
                            size="small" 
                            style="width: 100%;"
                            :disabled="!$store.getters.getUserInformation.is_a_production_supervisor"
                            v-model="scope.row.remarks">
                        </el-input>                
                        <span v-else class="rowFontSize">
                            {{scope.row.remarks}}
                        </span>
                    </template>
                </el-table-column>

                <el-table-column 
                    label="" 
                    align="right" 
                    v-if="!$store.getters.getPreferenceProps.sale_form_reduced && $store.getters.getUserInformation.is_a_production_supervisor && checkIfModuleAccessAvailable('/productionworkorders', 'can_edit')">
                    <template slot-scope="scope">
                        <el-dropdown 
                            v-if="scope.row.work_status >=1 && scope.row.main_work_log_id === 0"
                            @command="handleRowDropdownCommand">
                            <a>
                                <i class="el-icon-setting el-icon--right"></i><i class="el-icon-arrow-down el-icon--right"></i>
                            </a>
                            
                            <el-dropdown-menu slot="dropdown" align="left">
                                <el-dropdown-item 
                                    v-if="scope.row.qc_chart !== null && scope.row.qc_chart.length > 0 && scope.row.work_status >1"
                                    :command="{command: 'qcSheet', rowData: scope.row}">QC Sheet</el-dropdown-item>                        
                                <el-dropdown-item
                                    v-if="scope.row.work_status === 4"
                                    :command="{command: 'update', rowData: scope.row}">Update</el-dropdown-item>                        
                                <el-dropdown-item 
                                    v-if="scope.row.work_status === 4"
                                    :command="{command: 'restart', rowData: scope.row}">Restart Process</el-dropdown-item>
                                <el-dropdown-item 
                                    v-if="scope.row.work_status === 1"
                                    :command="{command: 'assignWO', rowData: scope.row}">Mark Finished</el-dropdown-item>
                                    
                            </el-dropdown-menu>
                        </el-dropdown>
                        
                    </template>
                </el-table-column>
                
                </el-table>
                
            </div>
            
        </div>

        <el-dialog
            :title="'QC Sheet'"
            v-if="show_qc_window"
            width="70%"
            :visible.sync="show_qc_window"
            append-to-body>
            <QCWindow
                :row_data="getRowData"
                :read_only="true"
                @closed="show_qc_window = false"/>
        </el-dialog>

  </div>
</template>

<script>
import QCWindow from './QCWindow'

export default {
    components: {QCWindow},
    props: ['production_id'],
    data() {
        return {
            show_qc_window: false,
            row_data: []
        }
    },
    computed: {
        getRowData() {
            return this.row_data
        },
        getProductionData() {
            let list = this.$store.getters.getProductionWorkOrderList

            if(list.filter(t => t.id == this.production_id).length>0) {
                return list.filter(t => t.id == this.production_id)[0]
            }

            return null
        }
    },
    methods: {
        handleRowDropdownCommand(command) {
            if(command.command == 'qcSheet') {
                this.row_data = command.rowData
                this.show_qc_window = true
            } else if(command.command == 'update') {
                this.submitUpdate(command.rowData)
            } else if(command.command == 'restart') {
                this.restartProcess(command.rowData)
            } else if(command.command == 'assignWO') {

                let findRowIndex = this.$store.state.production.assignment_history.findIndex(t => t.id === command.rowData.id)

                if(this.$store.state.production.assignment_history.length>(findRowIndex+1)) {
                    command.rowData.work_status = 4
                    this.submitUpdate(command.rowData)
                } else {
                    this.$emit('markAsFinishFromHistory', {command: 'assignWO', action_type: 'finish', production_work_row: this.getProductionData})
                }
                
            }
        },
        submitUpdate(rowData) {
            this.$store.dispatch('updateWorkOrderAssignmentHistory', rowData)
        },
        restartProcess(rowData) {
            
            this.$confirm('Are you sure to proceed?', 'Warning', {
                confirmButtonText: 'OK',
                cancelButtonText: 'Cancel',
                type: 'warning'
            }).then(() => {
                this.$store.dispatch('restartProductionProcess', {
                    production_id: rowData.production_id,
                    work_order_process_id: rowData.work_order_process_id
                })
            }).catch(() => {
                
            });
        }
    },
    mounted() {
        this.$store.dispatch('fetchWorkOrderAssignmentHistory', {production_id: this.production_id})     
    }
}
</script>

<style>

</style>


// WEBPACK FOOTER //
// src/views/Production/WorkOrderAssignmentHistory.vue